import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';

export default function Login() {
  const [email, setEmail]     = useState('admin@mehtaexports.com');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate  = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    if (!email || !password) return toast.error('Enter credentials');
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Welcome back!');
      navigate('/');
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-slate-900 flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="text-4xl mb-2">⚓</div>
          <h1 className="text-2xl font-black text-white tracking-tight">TradeFlow ERP</h1>
          <p className="text-slate-400 text-sm mt-1">Import · Export · Compliance</p>
          <div className="mt-2 text-xs text-amber-400 font-mono">iec.norissolutions.in</div>
        </div>

        {/* Card */}
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <h2 className="text-lg font-black text-slate-800 mb-1">Sign In</h2>
          <p className="text-sm text-slate-400 mb-6">Access your trade management portal</p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-xs font-semibold text-slate-600 block mb-1.5">Email Address</label>
              <input type="email" value={email} onChange={e=>setEmail(e.target.value)}
                className="w-full bg-slate-50 border border-slate-200 rounded-lg px-3 py-2.5 text-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                placeholder="admin@company.com" />
            </div>
            <div>
              <label className="text-xs font-semibold text-slate-600 block mb-1.5">Password</label>
              <input type="password" value={password} onChange={e=>setPassword(e.target.value)}
                className="w-full bg-slate-50 border border-slate-200 rounded-lg px-3 py-2.5 text-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                placeholder="Enter password" />
            </div>
            <button type="submit" disabled={loading}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-2.5 rounded-lg text-sm transition-all disabled:opacity-50 flex items-center justify-center gap-2">
              {loading ? <span className="animate-spin">⟳</span> : '🔐'} Sign In
            </button>
          </form>

          <div className="mt-6 pt-4 border-t border-slate-100">
            <p className="text-xs text-slate-400 text-center">Default: admin@mehtaexports.com / Admin@123</p>
          </div>
        </div>

        <p className="text-center text-slate-500 text-xs mt-6">
          Powered by <span className="text-amber-400 font-semibold">Noris Solutions</span>
        </p>
      </div>
    </div>
  );
}
